import { createAsyncThunk, createSelector, createSlice } from "@reduxjs/toolkit";
import { RootState, store } from "../../app/store";
import QueryHelper from "../../Components/Utilities/QueryHelper";
type TinyEditorToken = {
	text: string;
	value: string;
};

const staticTokens: TinyEditorToken[] = [
	{ text: "RecipientTemplateModel.FirstName", value: "{{RecipientTemplateModel.FirstName}}" },
	{ text: "RecipientTemplateModel.LastName", value: "{{RecipientTemplateModel.LastName}}" },
	{ text: "RecipientTemplateModel.FullName", value: "{{RecipientTemplateModel.FullName}}" },
];

let inflightPromise: Promise<TinyEditorToken[]> | null = null;

export const fetchTinyEditorTokens = createAsyncThunk("tinyEditor/fetchTokens", async (arg: { queryHelper: QueryHelper }) => {
	if (store.getState().tinyEditor?.tokens?.length) {
		return store.getState().tinyEditor.tokens;
	}
	if (inflightPromise) {
		return inflightPromise;
	}

	arg.queryHelper.setMace();
	inflightPromise = arg.queryHelper
		.get("EditorToken")
		.then((response) => {
			if (response && response.results && response.results.length > 0) {
				const tokens = response.results.map((token: any) => ({
					text: token.tokenText,
					value: token.tokenValue,
				}));
				return tokens;
			} else {
				return staticTokens;
			}
		})
		.catch((e) => {
			return staticTokens;
		})
		.finally(() => {
			inflightPromise = null;
		});
	return inflightPromise;
});

export const tinyEditorSlice = createSlice({
	name: "tinyEditor",
	initialState: {
		tokens: [] as TinyEditorToken[],
		loading: false,
	},
	reducers: {
		getTokens: (state, action) => {
			state.tokens = action.payload ?? [];
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchTinyEditorTokens.pending, (state) => {
				state.loading = true;
			})
			.addCase(fetchTinyEditorTokens.fulfilled, (state, action) => {
				state.tokens = action.payload ?? [];
				state.loading = false;
			})
			.addCase(fetchTinyEditorTokens.rejected, (state) => {
				state.loading = false;
			});
	},
});

export const selectTinyEditorTokens = createSelector(
	(state: RootState) => state.tinyEditor.tokens,
	(tokens) => tokens ?? []
);

export const selectTinyEditorLoading = (state: RootState) => state.tinyEditor.loading;
export const { getTokens } = tinyEditorSlice.actions;

const { reducer } = tinyEditorSlice;
export default reducer;
